import { defineNuxtPlugin } from '#app'

/**
  * This plugin ensures that existing SW from PWA plugins is deregistered
* for site visitors
  */
export default defineNuxtPlugin(() => {
  if (import.meta.client && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
    })
  }
})
